import { grey, blue, green, orange, red } from '../styles/colours';
export var ContentStylePropertiesByColor = {
    primary: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
        });
    },
    secondary: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentSecondary) !== null && _a !== void 0 ? _a : grey[800],
        });
    },
    tertiary: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentTertiary) !== null && _a !== void 0 ? _a : grey[600],
        });
    },
    accessory: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentAccessory) !== null && _a !== void 0 ? _a : grey[500],
        });
    },
    onColor: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentOnColor) !== null && _a !== void 0 ? _a : grey[0],
        });
    },
    accent: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentAccent) !== null && _a !== void 0 ? _a : blue[600],
        });
    },
    accentOnColor: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentAccentOnColor) !== null && _a !== void 0 ? _a : blue[800],
        });
    },
    positive: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentPositive) !== null && _a !== void 0 ? _a : green[800],
        });
    },
    positiveOnColor: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentPositiveOnColor) !== null && _a !== void 0 ? _a : green[900],
        });
    },
    warning: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentWarning) !== null && _a !== void 0 ? _a : orange[800],
        });
    },
    warningOnColor: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentWarningOnColor) !== null && _a !== void 0 ? _a : orange[900],
        });
    },
    negative: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentNegative) !== null && _a !== void 0 ? _a : red[800],
        });
    },
    negativeOnColor: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentNegativeOnColor) !== null && _a !== void 0 ? _a : red[900],
        });
    },
};
//# sourceMappingURL=ContentStylePropertiesByColor.js.map